import angular from 'angular';
import pipelineLabels from './pipelineLabels';
import './style.scss';

export default angular
  .module('components.pipelineLabels', [])
  .component('pipelineLabels', pipelineLabels).name;
